import * as React from 'react';
import { isNodeWiderThanParent } from '../../util/dom';
import { StyledDropdownItem } from '../Select/DropdownComponents';

const FilterSelectOption = props => {
  const { onClick, onMouseEnter, useGroups, option } = props;
  const optionRef = React.useRef();

  return (
    <StyledDropdownItem
      type="button"
      onMouseDown={e => e.preventDefault()}
      className="small-text-medium"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      data-for={isNodeWiderThanParent(optionRef) ? 'FilterSelectTooltip' : null}
      data-tip={option.label}
    >
      {useGroups ? (
        <div className="inline-flex-container w-100p">
          <div className="w-20p">
            {option.groupLabelVisible ?? option.group}
          </div>
          <div className="w-80p cut-text">
            <span ref={optionRef}>{option.label}</span>
          </div>
        </div>
      ) : (
        <span ref={optionRef}>{option.label}</span>
      )}
    </StyledDropdownItem>
  );
};

export default FilterSelectOption;
